
<template>
    <div>
        <topback title="Bank Kyc Parent" path="back"></topback>
        <div class="paymentmethods">
            <div class="noassets" v-if="list.length === 0">
                <md-result-page class="customized" img-url="/static/icon/kyc.png" text="no payment method"
                    subtext="">
                </md-result-page>
            </div>
            <md-bill v-for="bank in list" v-bind:key="bank.id">
                <template slot="header">
                    <pointtext class="paymentmethod-type" type="line-purple" :text="bank.bank_name + '-' + bank.name"></pointtext>
                    <div class="md-bill-no" @click="$_showActionSheet(bank)">
                        <iconimg name="edit" size="lg"></iconimg>
                    </div>
                </template>
                <md-detail-item title="Account">
                    {{ bank.bank_account }}
                </md-detail-item>
                <md-detail-item title="IFSC">
                    {{ bank.ifsc }}
                </md-detail-item>
                <md-detail-item title="status">
                    <pointtext class="ct-status" type="fail" text="Disabled" v-if="get_ct_status(bank.status) === 'Disabled'"></pointtext>
                    <pointtext class="ct-status" type="success" text="Active" v-if="get_ct_status(bank.status) === 'Active'"></pointtext>
                    <pointtext class="ct-status" type="notline" text="Pause" v-if="get_ct_status(bank.status) === 'Pause'"></pointtext>
                </md-detail-item>
                <md-detail-item title="Receiving">
                    <pointtext class="ct-status" type="success" text="In Receiving" v-if="bank.receiving"></pointtext>
                    <pointtext class="ct-status" type="notline" text="Wait" v-else></pointtext>
                </md-detail-item>
            </md-bill>
        </div>
        <md-button type="primary" @click="go_addpaymentmethod">Add Bank Card</md-button>
    </div>
</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import { ActionSheet } from 'mand-mobile'
import { getbanklist, pausebank } from '@/request/api'


export default {
    name: 'paymentmethods',
    components: {
		[topback.name]: topback,
        [iconimg.name]: iconimg,
        [pointtext.name]: pointtext
    },

    data() {
        return {
            list: []
        }
    },
    created() {
        this.getbanks();
    },
    methods: {
        getbanks() {
            getbanklist().then(res=>{
                if(res.code === 200) {
                    this.list = res.data;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        },
        go_addpaymentmethod() {
            this.$router.push('/bankadd')
        },
        go_edit(id) {
            this.$router.push('/editbank/' + id);
        },
        get_ct_status(status) {
            if (status === 'unavailable') {
                return "Disabled";
            }
            if (status === 'available') {
                return 'Active';
            }
            if (status === 'pause') {
                return 'Pause';
            }
            if (status == 'waitauth') {
                return 'WaitAuth';
            }
        },
        get_operate_options(){
            let ct_status = this.get_ct_status(this.bank.status);
            let options = [];
            if(ct_status === 'Active') {
                options = [
                    {
                        label: 'Pause',
                        value: 'pause'
                    },
                ];
                return options
            } else if(ct_status === 'Pause') {
                return [
                    {
                        label: 'Active',
                        value: 'available',
                    },
                    {
                        label: 'Edit',
                        value: 'edit',
                    }
                ]
            } else {
                return [
                    {
                        label: 'Edit',
                        value: 'edit',
                    }
                ]
            }
        },
        $_showActionSheet(bank) {
            this.bank = bank;
            let options = this.get_operate_options();
            ActionSheet.create({
                value: true,
                title: 'Operate Bank',
                options: options,
                defaultIndex: 0,
                cancelText: 'Cancel',
                onCancel: this.$_cancel,
                onSelected: this.$_selected,
            })
        },
        $_selected(item) {
            if(item.value === 'pause') {
                this.pause('pause');
            } else if (item.value === 'edit') {
                this.$router.push('/editbank/' + this.bank.id);
            } else if (item.value === 'available') {
                this.pause('available');
            }
        },
        $_cancel() {
            console.log('action-sheet cancel')
        },
        pause(status) {
            pausebank({id: this.bank.id, status: status}).then(res=>{
                if(res.code === 200) {
                    this.$toast.succeed("Successfully");
                    this.getbanks();
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        }
    }
}

</script>

<style scoped>
.paymentmethods {
    margin-top: 0.8rem;
}
.paymentmethod-type {
    font-size: 0.26rem;
}
.paymentmethod-type >>> span {
    color: black !important;
    font-weight: 400;
}
.noassets {
    margin-top: 1.5rem;
    margin-bottom: 0.2rem;
}

.noassets>>>.md-result-image {
    width: 1.6rem;
}

.noassets>>>.md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets>>>.md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/bank.vue